import styled from "styled-components";
import { tablet } from "../../../utils/breakpoints";

export const Logo = styled.img`
  grid-area: logo;
  justify-self: center;
  ${tablet} {
    width: 60%;
  }
  width: 300px;
`;

export const Text = styled.div`
  grid-area: text;
  align-self: center;
  width: 100%;
  h1 {
    ${tablet} {
      font-size: 19px;
    }
    font-size: 49px;
    text-align: center;
  }
`;

export const ContentContainer = styled.div`
  display: grid;
  grid-area: main;
  align-self: center;
  grid-template-areas: "logo" "text";
  justify-items: center;
  a {
    display: grid;
  }
`;
